const getAssetBase = () => {
  if (typeof window === 'undefined') return ''
  const base = window.__WIDGET_ASSET_BASE__
  if (typeof base === 'string') return base
  return base?.default || ''
}

export const resolveWidgetAsset = (path) => {
  const base = getAssetBase()
  if (!base) return path
  const normalized = path.startsWith('/') ? path.slice(1) : path
  return new URL(normalized, base).toString()
}

// Product images are served by purmo.com at /product-media/* for every brand, and the API returns
// them as relative paths. Embedded widgets keep the relative path: every site that embeds the
// widget serves /product-media itself. Outside widget mode (dev server, standalone page) there is
// no such path, so it is made absolute against purmo.com. The host page can override the base with
// window.__WIDGET_MEDIA_BASE__ in either mode (an empty string keeps paths relative).
export const DEFAULT_MEDIA_BASE = 'https://www.purmo.com'

export const resolveMediaUrl = (url) => {
  if (typeof url !== 'string' || !url.startsWith('/product-media/')) return url
  if (typeof window === 'undefined') return url
  const base =
    typeof window.__WIDGET_MEDIA_BASE__ === 'string'
      ? window.__WIDGET_MEDIA_BASE__
      : window.__WIDGET_MODE__ === true
        ? ''
        : DEFAULT_MEDIA_BASE
  return base ? new URL(url, base).toString() : url
}
